// Apolo IDE — useBreakpoint (Sprint v6).
//
// Returns the active breakpoint label based on window.innerWidth. SSR-safe
// (returns 'lg' on the server). Mirrors Tailwind's scale so callers can
// gate JSX with the same vocabulary CSS uses.

import { useState, useEffect } from 'react';
import { BREAKPOINTS } from '../lib/breakpoints.js';

function getCurrentBreakpoint() {
  if (typeof window === 'undefined') return 'lg';
  const w = window.innerWidth;
  if (w < BREAKPOINTS.sm)   return 'xs';
  if (w < BREAKPOINTS.md)   return 'sm';
  if (w < BREAKPOINTS.lg)   return 'md';
  if (w < BREAKPOINTS.xl)   return 'lg';
  if (w < BREAKPOINTS['2xl']) return 'xl';
  return '2xl';
}

export function useBreakpoint() {
  const [bp, setBp] = useState(getCurrentBreakpoint);
  useEffect(() => {
    const handler = () => setBp(getCurrentBreakpoint());
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return bp;
}
